import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
//import { stringify } from 'querystring';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { HomeService } from './home.service';
import { SearchService } from './search.service';
import { DownloadHistory, UserClient } from '../models/walai';
import { HttpClient } from '@angular/common/http';
import { AdminService } from './admin.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  // เรียกใช้ใน app หรือ component หลัก เพื่อ set ค่า BG Footer จาก API
  private footerColorsInitialized = false;
  themeName: string = 'theme-ocean';

  // เรียกใช้ใน app หรือ component หลัก เพื่อ set ค่า BG Footer จาก API
  initFooterColors(adminService: AdminService) {
    if (this.footerColorsInitialized) {
      return;
    }
    this.footerColorsInitialized = true;

    const processColor = (key: string, label: string, updateFn: (val: string) => void) => {
      const cacheKey = `wl_cached_${key}`;
      const cachedValue = localStorage.getItem(cacheKey);

      if (cachedValue) {
        updateFn(cachedValue);
      } else {
        adminService.getColorSettingPipe(key).pipe(
          filter((res: any) => res && res.status === 200 && typeof res.body === 'string' && res.body.trim() !== ''),
          map((res: any) => res.body.trim() as string)
        ).subscribe(color => {
          localStorage.setItem(cacheKey, color);
          updateFn(color);
        });
      }
    };

    processColor('FooterBg', 'BG Footer', (color) => this.updatecolorBGFooter(color));
    processColor('FooterColor', 'Footer Color', (color) => this.updatecolorFooter(color));
  }
  constructor(
    private homeService: HomeService,
    private ss: SearchService,
    private http: HttpClient,
    public translate: TranslateService
  ) { }


  private tokenPV = new BehaviorSubject<string>(localStorage.getItem('keyPV') == null ? '' : localStorage.getItem('keyPV'));
  currentTokenPV = this.tokenPV.asObservable();
  updateTokenPV(data: string) {
    localStorage.setItem('keyPV', data)
    this.tokenPV.next(data);
  }

  private PVPointOwner = new BehaviorSubject<number>(0);
  currentPVPointOwner = this.PVPointOwner.asObservable();
  updatePVPoint(data: number) {
    this.PVPointOwner.next(data);
  }


  private IsPVOpen = new BehaviorSubject<boolean>(localStorage.getItem('IsPVopen') == null ? false : Boolean(localStorage.getItem('IsPVopen').toString()));
  currentIsPVOpen = this.IsPVOpen.asObservable();
  updateIsPVOpen(data: boolean) {
    localStorage.setItem('IsPVopen', String(data))
    this.IsPVOpen.next(data);
  }


  private countNoti = new BehaviorSubject<number>(0);
  currentNoti = this.countNoti.asObservable();

  private NotiStyle = new BehaviorSubject<string>('d-none');
  currentNotiStyle = this.NotiStyle.asObservable();

  // private profile = new BehaviorSubject<string>('d-flex');

  private countHold = new BehaviorSubject<number>(0);
  currentHold = this.countHold.asObservable();

  private countCollection = new BehaviorSubject<number>(0);
  currentCountCollection = this.countCollection.asObservable();

  private countSuggest = new BehaviorSubject<string>('0');
  currentCountSuggest = this.countSuggest.asObservable();

  private countReviews = new BehaviorSubject<number>(0);
  currentCountReviews = this.countReviews.asObservable();

  private countTags = new BehaviorSubject<number>(0);
  currentCountTags = this.countTags.asObservable();



  private countSuggestFriend = new BehaviorSubject<number>(0);
  currentCountSuggestFriend = this.countSuggestFriend.asObservable();



  private CountNDDBasketlist = new BehaviorSubject<number>(0);
  currentCountNDDBasketlist = this.CountNDDBasketlist.asObservable();

  // private countDeliveryOrder = new BehaviorSubject<number>(0);
  // currentCountDeliveryOrder = this.countDeliveryOrder.asObservable();

  private bibList = new BehaviorSubject([]);
  currentBibList = this.bibList.asObservable();

  private mail = new BehaviorSubject<string>('');
  currentMail = this.mail.asObservable();
  updatemail(data: string) {
    this.mail.next(data);
  }

  private Fname = new BehaviorSubject<string>('');
  currentFname = this.Fname.asObservable();
  updateFname(data: string) {
    this.Fname.next(data);
  }

  private Lname = new BehaviorSubject<string>('');
  currentLname = this.Lname.asObservable();
  updateLname(data: string) {
    this.Lname.next(data);
  }

  private memberAccount = new BehaviorSubject<any[]>([]);
  currentMemberAccountg = this.memberAccount.asObservable();
  updateMemberAccount(data: any[]) {
    this.memberAccount.next(data);
  }

  private MemberImg = new BehaviorSubject<string>('');
  currentMemberImg = this.MemberImg.asObservable();
  updateMemberImg(data: string) {
    this.MemberImg.next(data);
  }

  private logo = new BehaviorSubject<string>('');
  currentlogo = this.logo.asObservable();
  updatelogo(data: string) {
    this.logo.next(data);
  }

  private colorFooter = new BehaviorSubject<string>('var(--wl-color-footer)');
  currentcolorFooter = this.colorFooter.asObservable();
  updatecolorFooter(data: string) {
    this.colorFooter.next(data);
  }

  private colorBGFooter = new BehaviorSubject<string>(
    'var(--wl-bg-color-footer)'
  );
  currentcolorBGFooter = this.colorBGFooter.asObservable();
  updatecolorBGFooter(data: string) {
    this.colorBGFooter.next(data);
  }

  updateUserData(data: any) {
    this.bibList.next(data);
  }


  changeCountHold(countHold: number) {
    this.countHold.next(countHold);
  }

  changeCountNoti(countNoti: number) {
    this.countNoti.next(countNoti);
  }

  changeNotiStyle(style: string) {
    this.NotiStyle.next(style);
  }

  changeCountCollection(countCollection: number) {
    this.countCollection.next(countCollection);
  }

  changeCountSuggest(countSuggest: string) {
    this.countSuggest.next(countSuggest);
  }

  changeCountReviews(countReviews: number) {
    this.countReviews.next(countReviews);
  }
  changeCountTags(countTags: number) {
    this.countTags.next(countTags);
  }

  changeCountSuggestFriend(countTags: number) {
    this.countSuggestFriend.next(countTags);
  }


  changeCountNDDBasketlist(CountNDDBasketlist: number) {
    this.CountNDDBasketlist.next(CountNDDBasketlist);
  }

  // changeCountDeliveryOrder(countDeliveryOrder: number){
  //   this.countDeliveryOrder.next(countDeliveryOrder);
  // }

  saveForExport(bibid: string) {
    let listBib: any = [];
    if (localStorage.getItem('listBib') != null) {
      let bibStr: any = localStorage.getItem('listBib');
      var splitted = bibStr.split(',');
      splitted.forEach((element: any) => {
        if (element != '') {
          listBib.push(element);
        }
      });
    }

    if (listBib.indexOf(bibid, 0) == -1) {
      //เช็คซ้ำ
      listBib.push(bibid);
      this.updateUserData(listBib);
      localStorage.setItem('listBib', listBib);
    }

    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: this.translate.instant('BookSaved'),
      showConfirmButton: false,
      timer: 1500,
    });
  }

  getLogo() {
    this.homeService.getFilePath('Logo').subscribe(async (data: any) => {
      return data + 'web-logo.png';
    });
  }



  // getNoBookCover() {
  //   this.memberService
  //   .opacMemberBorrow(this.USERID)
  //   .subscribe((bookBorrow: any) => {
  //     this.bookListCheckedOut = bookBorrow;
  //     this.countCheckedOut = this.bookListCheckedOut.length;
  //   });




  // }

  // getNoBookCover() {
  // return `${environment.imageUrl}/opacimages/noimage.jpg`
  // }

  addDownloadHistory(bibid: string, url: string) {
    try {
      // Use JSONP to fetch public IP (avoids CORS preflight and custom header issues)
      this.http
        .jsonp('https://api.ipify.org?format=jsonp', 'callback')
        .subscribe((res: any) => {
          const ip = res && (res.ip || res.IPv4) ? (res.ip || res.IPv4) : '';
          var data: DownloadHistory = {
            BIBID: bibid,
            URL: url,
            USERIPADDRESS: ip,
            USERAGENT: window.navigator.userAgent,
          };

          this.ss.addDownloadHistory(data).subscribe(
            (results: any) => { },
            (error) => { }
          );
        }, () => {
          // Fallback: try geolocation-db (may be blocked by CORS if interceptors add headers)
          this.http.get('https://geolocation-db.com/json/').subscribe((res: any) => {
            var data: DownloadHistory = {
              BIBID: bibid,
              URL: url,
              USERIPADDRESS: res && res.IPv4 ? res.IPv4 : '',
              USERAGENT: window.navigator.userAgent,
            };
            this.ss.addDownloadHistory(data).subscribe(() => { }, () => { });
          }, () => { });
        });
    } catch (error) { }
  }

  addOpacview() {

    try {
      // Use JSONP to fetch public IP to avoid CORS issues with custom headers
      this.http
        .jsonp('https://api.ipify.org?format=jsonp', 'callback')
        .subscribe((res: any) => {
          const ip = res && (res.ip || res.IPv4) ? (res.ip || res.IPv4) : '';
          var data: UserClient = {
            ipaddress: ip,
            agent: window.navigator.userAgent,
          };
          this.homeService.addOpacview(data).subscribe(
            (results: any) => { },
            (error) => { }
          );
        }, () => {
          // Fallback to geolocation-db if JSONP fails
          this.http.get('https://geolocation-db.com/json/').subscribe((res: any) => {
            var data: UserClient = {
              ipaddress: res && res.IPv4 ? res.IPv4 : '',
              agent: window.navigator.userAgent,
            };
            this.homeService.addOpacview(data).subscribe(() => { }, () => { });
          }, () => { });
        });
    } catch (error) { }
  }



}
